import { COMPONENT_NAME_PREFIX } from '../constants';
var elementName = COMPONENT_NAME_PREFIX + "checkbox";
var classes = {
    CONTAINER: 'tyl-checkbox-container',
    ROOT: 'tyl-checkbox',
    CHECKBOX: 'tyl-checkbox',
    CHECKBOX_DENSE: 'tyl-checkbox--dense',
    ANIM_CHECKED_INDETERMINATE: 'tyl-checkbox--anim-checked-indeterminate',
    ANIM_CHECKED_UNCHECKED: 'tyl-checkbox--anim-checked-unchecked',
    ANIM_INDETERMINATE_CHECKED: 'tyl-checkbox--anim-indeterminate-checked',
    ANIM_INDETERMINATE_UNCHECKED: 'tyl-checkbox--anim-indeterminate-unchecked',
    ANIM_UNCHECKED_CHECKED: 'tyl-checkbox--anim-unchecked-checked',
    ANIM_UNCHECKED_INDETERMINATE: 'tyl-checkbox--anim-unchecked-indeterminate',
    BACKGROUND: 'tyl-checkbox__background',
    CHECKED: 'tyl-checkbox--checked',
    CHECKMARK: 'tyl-checkbox__checkmark',
    CHECKMARK_PATH: 'tyl-checkbox__checkmark-path',
    DISABLED: 'tyl-checkbox--disabled',
    INDETERMINATE: 'tyl-checkbox--indeterminate',
    MIXEDMARK: 'tyl-checkbox__mixedmark',
    SELECTED: 'tyl-checkbox--selected',
    UPGRADED: 'tyl-checkbox--upgraded',
    FOCUSED: 'tyl-checkbox--focused',
    ENABLED: 'tyl-checkbox--enabled'
};
var selectors = {
    INPUT: 'input',
    LABEL: 'label',
    ROOT: "." + classes.ROOT
};
var attributes = {
    DENSE: 'dense',
    CHECKED: 'checked',
    SLOT: 'slot',
    DISABLED: 'disabled',
    INDETERMINATE: 'indeterminate'
};
export var strings = {
    ARIA_CHECKED_ATTR: 'aria-checked',
    ARIA_CHECKED_INDETERMINATE_VALUE: 'mixed',
    DATA_INDETERMINATE_ATTR: 'data-indeterminate',
    NATIVE_CONTROL_SELECTOR: '.tyl-checkbox__native-control',
    TRANSITION_STATE_CHECKED: 'checked',
    TRANSITION_STATE_INDETERMINATE: 'indeterminate',
    TRANSITION_STATE_INIT: 'init',
    TRANSITION_STATE_UNCHECKED: 'unchecked'
};
var CB_PROTO_PROPS = ['checked', 'indeterminate', 'disabled'];
export var numbers = {
    ANIM_END_LATCH_MS: 250
};
export var CHECKBOX_CONSTANTS = {
    elementName: elementName,
    classes: classes,
    selectors: selectors,
    attributes: attributes,
    strings: strings,
    CB_PROTO_PROPS: CB_PROTO_PROPS,
    numbers: numbers
};
